import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { StampCardRow } from '@models/stamp';
import { useFlow } from '@stackflow/react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import StampIcon from './StampIcon';

interface Props {
    card: StampCardRow;
}

function StampCard({ card }:Props) {
    const {
        stampExpiredDays, stampCount, totalSlots, targetScope, shopId,
    } = card;
    const { t } = useTranslation('stamp');
    const [expireIndex, setExpireIndex] = useState<number>(-1);
    const { push, replace } = useFlow();
    const handleOrder = () => {
        if (targetScope === 'SHOP') {
            replace('ShopListActivity', { type: 'LIST', isOrder: true });
            push('ShopDetailBottomSheet', { shopId: shopId! });
        } else {
            replace('ShopListActivity', { type: 'LIST', isOrder: true });
        }
    };
    return (
        <Container>
            <Row fullWidth justify='space-between' align='center'>
                <Text size='title-lg'>
                    <Trans ns='stamp'
                        i18nKey='card.remainingStamps'
                        values={{ count: totalSlots - stampCount }}
                        components={{ br: <br />, b: <b /> }} />
                </Text>
                <Row spacing={1} onClick={handleOrder}>
                    <Text color={colors.textThird}>
                        {t('card.orderPrompt')}
                    </Text>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 13L10 8L5 3" stroke="#AFA8A5" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </Row>
            </Row>
            <Contents>
                {Array.from({ length: totalSlots }).map((_, value) => (
                    <StampIcon key={`icon ${value}`}
                        value={value}
                        stampCount={stampCount}
                        expireIndex={expireIndex}
                        setExpireIndex={setExpireIndex}
                        stampExpireDay={stampExpiredDays?.[value]}
                    />
                ))}
            </Contents>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    border-radius: 16px;
    padding: 24px 16px;
    min-width: calc(100vw - 32px);
    scroll-snap-align: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const Contents = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
`;

export default StampCard;
